import { t } from "@/lib/i18n";
export default function Logo({ className = "text-2xl", light = false, tagline = false }) {
  return (
    <span className="inline-flex flex-col leading-none pt-[0.5em]" data-testid="brand-logo">
      <span className={`font-display font-bold tracking-tight inline-flex items-end ${light ? "text-white" : "text-slate-900"} ${className}`}>
        M
        <span className="relative text-amber-600">
          ı
          <svg viewBox="0 0 24 32" className="absolute left-1/2 -translate-x-1/2 -top-[0.42em] w-[0.42em] h-[0.56em]" aria-hidden="true">
            <path fill="currentColor" fillRule="evenodd" d="M12 0C5.4 0 0 5.2 0 11.6 0 20.3 12 32 12 32s12-11.7 12-20.4C24 5.2 18.6 0 12 0zm0 16.5a5 5 0 110-10 5 5 0 010 10z" />
          </svg>
        </span>
        <span className="mx-[0.18em]">-</span>Load
      </span>
      {tagline && <span className={`text-[0.7rem] mt-1 tracking-wide ${light ? "text-white/80" : "text-slate-600"}`}>{t("Logistics Marketplace")}</span>}
    </span>
  );
}
